export default [
  {
    title: `Offline First Mobile App`,
    description: `Don't depend on Connectivity. Being Offline Enabled ensures you'll capture every detail in the field.`,
    icon: 'offlineFirst'
  },
  {
    title: `Emphasize Great Work`,
    description: `Employees respond negatively to classic grading scales, leading to reduced job satisfaction. With Route, you can focus on the Positive.`,
    icon: 'greatWork'
  },
  {
    title: `Markup Photos By Area`,
    description: `Show employees exactly where they can improve with pictures and markup editing.`,
    icon: 'photoMarkup'
  },
  {
    title: `Simple One-Click Sharing`,
    description: `Review clean and organized Walkthrough data from any device. Export it to PDF to easily share with your team or client.`,
    icon: 'oneClickSharing'
  }
]
